<template><div><h1 id="spendenbescheinigungsportal-–-anwendungsfalle-voraussetzungen" tabindex="-1"><a class="header-anchor" href="#spendenbescheinigungsportal-–-anwendungsfalle-voraussetzungen"><span>Spendenbescheinigungsportal – Anwendungsfälle &amp; Voraussetzungen</span></a></h1>
<h2 id="einfuhrung" tabindex="-1"><a class="header-anchor" href="#einfuhrung"><span>Einführung</span></a></h2>
<p>Das <strong>Spendenbescheinigungsportal</strong> von funtrade ist eine Online-Plattform, die es Spender:innen ermöglicht, ihre <strong>jährliche Spendenbescheinigung</strong> bequem selbst herunterzuladen.
Der Zugriff erfolgt über eine <strong>Kennung</strong> und einen <strong>Code</strong>, die individuell auf der Spendenbescheinigung vermerkt sind.</p>
<p>Das Portal kann einfach in die eigene Webseite der Organisation eingebunden werden und bietet darüber hinaus die Möglichkeit, die <strong>Kontaktpräferenzen der Spender:innen</strong> für das kommende Jahr abzufragen.
Dadurch können Spender:innen, die bislang per Post angeschrieben werden, künftig ihre Spendenbescheinigung oder den Zugangscode per <strong>E-Mail</strong> erhalten, falls sie das wünschen.</p>
<p>Diese Option unterstützt Organisationen dabei, ihre Prozesse zu <strong>digitalisieren</strong> und <strong>Druck- sowie Portokosten</strong> nachhaltig zu reduzieren.</p>
<p>Das Spendenportal kann bis zu einem gewissen Grad auf das CI (Farben, Formen) der Webseite der Organisation angepasst werden.</p>
<hr>
<h2 id="was-wird-benotigt" tabindex="-1"><a class="header-anchor" href="#was-wird-benotigt"><span>Was wird benötigt?</span></a></h2>
<p>Das Spendenbescheinigungsportal erlaubt den Download der Spendenbescheinigungen über Kennung und Code.
Damit das funktioniert, werden pro Bescheinigung folgende Angaben/Dinge benötigt:</p>
<ul>
<li><strong>PDF-Dokument</strong> der Spendenbescheinigung pro Spender einzeln</li>
<li><strong>Dateiname</strong> des PDF-Dokuments pro Spender</li>
<li><strong>Kennung</strong>, die im PDF ersichtlich ist</li>
<li><strong>Code</strong>, der im PDF ersichtlich ist</li>
</ul>
<p>Bevor die Spendenbescheinigungen gedruckt werden, muss die <strong>exakte URL</strong> definiert werden.
Diese URL sollte auf jeder Bescheinigung erscheinen – idealerweise als <strong>QR-Code</strong> und zusätzlich als <strong>Klartext-Link</strong>, damit der Zugang für alle Spender:innen gewährleistet ist.</p>
<ul>
<li>Beispiel: <code v-pre>https://spendenbescheinigung.lebensbaum.org</code> oder <code v-pre>https://www.lebensbaum.org/spendenbescheinigung</code></li>
</ul>
<hr>
<h2 id="varianten-der-erstellung" tabindex="-1"><a class="header-anchor" href="#varianten-der-erstellung"><span>Varianten der Erstellung</span></a></h2>
<h3 id="variante-1-spendenbescheinigungen-in-funtrade-generieren" tabindex="-1"><a class="header-anchor" href="#variante-1-spendenbescheinigungen-in-funtrade-generieren"><span>Variante 1: Spendenbescheinigungen in <strong>funtrade</strong> generieren</span></a></h3>
<ul>
<li><strong>Voraussetzung:</strong> Eine Dokumentvorlage ist in funtrade hinterlegt; die Bescheinigung wird vollständig in funtrade erzeugt.</li>
<li><strong>Zielgruppe:</strong> Organisationen mit kleiner bis mittlerer Auflage, die die Bescheinigungen selbst drucken.</li>
<li><strong>Ablauf:</strong>
<ul>
<li>Die Spendenbescheinigungen werden wie üblich über den Document-Output (DO) erstellt und auf dem Büro-Drucker gedruckt</li>
<li>Das Team von funtrade liest die benötigten Informationen (PDF, Dateiname, Kennung, Code) direkt aus dem System aus.</li>
<li>Der <strong>Transfer ins Spendenportal</strong> erfolgt durch funtrade.</li>
</ul>
</li>
</ul>
<hr>
<h3 id="variante-2-spendenbescheinigungen-werden-von-der-druckerei-produziert" tabindex="-1"><a class="header-anchor" href="#variante-2-spendenbescheinigungen-werden-von-der-druckerei-produziert"><span>Variante 2: Spendenbescheinigungen werden von der <strong>Druckerei</strong> produziert</span></a></h3>
<ul>
<li><strong>Was benötigt wird:</strong>
<ul>
<li>Die finalen <strong>PDF-Dokumente</strong></li>
<li>Eine <strong>Excel-Liste</strong> mit folgenden Spalten:
<ul>
<li><em>PDF-Dateiname</em>: dieser muss mit den Dateien übereinstimmen</li>
<li><em>Kennung</em></li>
<li><em>Code</em></li>
</ul>
</li>
</ul>
</li>
<li><strong>Ablauf</strong>
<ul>
<li>Segmentierung wird in funtrade erstellt</li>
<li>Adressexport: Kennung und Code werden ebenfalls von funtrade generiert (Normalfall) oder später durch die Druckerei (Spezialfall)</li>
<li>Dokumente werden von der Druckerei erstellt (PDF) &amp; gedruckt (Brief)</li>
<li>Dateien werden an funtrade übermittelt</li>
<li>Der <strong>Transfer ins Spendenportal</strong> erfolgt durch funtrade.</li>
</ul>
</li>
</ul>
<hr>
<h2 id="technische-integration-des-spendenportals" tabindex="-1"><a class="header-anchor" href="#technische-integration-des-spendenportals"><span>Technische Integration des Spendenportals</span></a></h2>
<ul>
<li>Das Spendenbescheinigungsportal wird von <strong>funtrade gehostet</strong>.</li>
<li>Die Einbindung auf der Website erfolgt bequem per <strong>iFrame</strong>.</li>
<li>Damit sich das iFrame automatisch an die Seitenhöhe anpasst, sind <strong>kleine technische Anpassungen</strong> (CSS/JavaScript) nötig.
Diese werden gemeinsam mit dem/der Webmaster:in auf Basis einer kurzen technischen Dokumentation vorgenommen.</li>
</ul>
<hr>
<h2 id="allgemeine-voraussetzungen-kurzuberblick" tabindex="-1"><a class="header-anchor" href="#allgemeine-voraussetzungen-kurzuberblick"><span>Allgemeine Voraussetzungen (Kurzüberblick)</span></a></h2>
<ul>
<li><strong>Datenbasis:</strong> Pro Bescheinigung liegen <strong>PDF, Dateiname, Kennung und Code</strong> vor.</li>
<li><strong>Sichtbarkeit:</strong> <strong>Kennung</strong> und <strong>Code</strong> sind im PDF <strong>abgedruckt</strong>.</li>
<li><strong>Übermittlung (Variante 2):</strong> PDFs + Excel-Liste (Dateiname, Kennung, Code), idealerweise als <strong>passwortgeschütztes ZIP</strong>.</li>
<li><strong>Web-Integration:</strong> iFrame-Einbindung, kleine CSS/JS-Feinjustierungen zur responsiven Darstellung.</li>
<li><strong>Kommunikation:</strong> <strong>Portal-URL</strong> frühzeitig festlegen, damit sie rechtzeitig in Layout und Druck integriert werden kann.</li>
</ul>
<hr>
<h2 id="mini-checkliste" tabindex="-1"><a class="header-anchor" href="#mini-checkliste"><span>Mini-Checkliste</span></a></h2>
<ol>
<li>Dokumentvorlage in funtrade vorhanden <strong>oder</strong> Druckerei-Lieferpaket (PDFs + Excel) organisiert?</li>
<li>Sind <strong>Kennung &amp; Code</strong> im PDF sichtbar?</li>
<li>Ist die <strong>Portal-URL</strong> final und im Layout (Text + QR) platziert?</li>
<li>iFrame-Einbindung mit Webmaster:in abgestimmt?</li>
<li>(Variante 2) Sicherer <strong>Daten-Transfer</strong> an funtrade eingerichtet?</li>
</ol>
</div></template>


